import styled from 'styled-components'
import {StyledButton} from "../../../components/Buttons/DefaultButton/DefaultButton.styles";

export const Page = styled.div`
    height: 100%;
    width: 100%;
    background: url('images/Mask_group.svg');
    background-size: cover;

  .headContainer {
    display: flex;
    flex-direction: row;

    .title {
      padding-left: 1rem;
    }
  }

  .navbar {
    position: relative !important;
  }

  .modal-center {
    display: flex;
    justify-content: center;
  }

  .hidden {
    display: none;
  }
`

export const InputPhoneRoleBlock = styled.div`
    display: flex;
    flex-direction: row;
    gap: 1rem;

    @media only screen and (max-width: 400px) {
        flex-direction: column;
    }
`

export const CountrySelectBlock = styled.div`
    display: flex;
    flex-direction: row;
    gap: 1rem;
    align-items: center;

    @media only screen and (max-width: 400px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 0;
    }
`

export const ContinueButton = styled(StyledButton)`
    max-width: 24rem;
    align-self: center;

    @media only screen and (min-width: 900px) {
        margin-top: 2rem !important;
    }
`

export const ChangeRoleBlock = styled.div`
    display: flex;
    flex-direction: row;
    white-space: break-spaces;
    justify-content: center;
    margin-top: 1rem;
    
    a {
        text-decoration: underline;
        cursor: pointer;
    }
    
    @media only screen and (max-width: 400px) {
        flex-direction: column;
        align-items: center;
        white-space: unset;
    }
`

export const HeaderCountrySelect = styled.p`
        color: #000;
        font-feature-settings: 'clig' off, 'liga' off;
        font-size: 1rem;
        font-style: normal;
        font-weight: 400;
        line-height: 1.5rem; /* 150% */
        letter-spacing: 0.15px;
`

export const BodyCountrySelect = styled.p`
    display: flex;
    flex-direction: row;
    gap: 1rem;

    @media only screen and (max-width: 400px) {
        flex-direction: column;
        gap: 0;
    }
`

export const BodyContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-self: center;
    margin: 1rem 0 0;
`

export const Container = styled.div`
  overflow: auto;
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: val(--primary-contrast);
  align-items: center;
  height: 100%;

    .contentBlock {
      .halfWidth {
        max-width: 50%;
      }

      .inputBox {
        display: flex;
        flex-direction: row;
      }
      
      .inputBlock {
        gap: 1rem;
      }

      .inputTextField:not(:last-child) {
        margin-right: 0.5rem;
      }
      
      .signOutButton {
        color: var(--secondary-main);
        border-radius: unset;
        background-color: unset;
        box-shadow: unset;
      }

      .arrowIconFwdWhite {
        height: 1.5rem;
        padding-left: 0.5rem;
      }

      .logoImg {
        width: 220px;
      }

      .inset {
        margin: 0 0 1rem;
        font-size:13px;
      }

      .optional {
        white-space: pre;
      }
    }
`
